import {
  Card,
  CardContent,
  Box,
  Divider,
} from '@mui/material';
import CustomTextField from '../../../../../components/CustomTextField';
import { VIEW_MODE } from '../../../../../consts/enums';
import { Trash } from '../../../../../icons/trash';
import { KeyAttributesItemStyle, boxFlexDirection } from './style';

const nameKey = 'name';
const descriptionKey = 'description';

type KeyAttributesItemProps = {
  id: string
  name: string,
  description: string,
  onRemoveClick?: (id: string) => void,
  onValueChanged?: (updatedItem: Attributes) => void,
  error: Attributes | null,
  disabled?: boolean,
  viewMode: ViewMode
}

export const KeyAttributesItem = ({
  id,
  name,
  description,
  onRemoveClick,
  onValueChanged = () => { /* noop */ },
  error,
  disabled = false,
  viewMode,
}:KeyAttributesItemProps): JSX.Element => {
  const handleNameChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target) {
      onValueChanged({
        id,
        name: event.target.value,
        description,
      });
    }
  };

  const handleDescriptionChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target) {
      onValueChanged({
        id,
        name,
        description: event.target.value,
      });
    }
  };

  const isError = (key: string) => {
    if (error) {
      return error[key as keyof Attributes] !== '';
    }

    return false;
  };

  const getErrorText = (key: string) => isError(key) ? error && error[key as keyof Attributes] : '';

  const defineHeadline = () => (
    <CustomTextField
      viewMode={ viewMode }
      id={ `${id}${nameKey}` }
      label="Headline"
      type="input"
      value={ name }
      onChange={ handleNameChanged }
      style={ KeyAttributesItemStyle.nameField }
      error={ isError(nameKey) }
      FormHelperTextProps={ KeyAttributesItemStyle.formHelper }
      helperText={ getErrorText(nameKey) }
      disabled={ disabled }
    />
  );

  const defineDescription = () => (
    <CustomTextField
      viewMode={ viewMode }
      id={ `${id}${descriptionKey}` }
      label="Description"
      type="input"
      value={ description }
      onChange={ handleDescriptionChanged }
      style={ KeyAttributesItemStyle.descriptionField }
      error={ isError(descriptionKey) }
      FormHelperTextProps={ KeyAttributesItemStyle.formHelper }
      helperText={ getErrorText(descriptionKey) }
      disabled={ disabled }
    />
  );

  const canRemove = typeof onRemoveClick === 'function' && viewMode === VIEW_MODE.EDITABLE;

  return (
    <Card style={ KeyAttributesItemStyle.card } >
      <CardContent style={ KeyAttributesItemStyle.cardContent }>
        <Box
          component="form"
          flexDirection={ boxFlexDirection }
          style={ KeyAttributesItemStyle.box }
        >
          {defineHeadline()}
          {defineDescription()}

          {canRemove && (
            <>
              <Divider />
              <Trash
                style={ KeyAttributesItemStyle.icon }
                onClick={ () => onRemoveClick(id) }
              />
            </>

          )}
        </Box>
      </CardContent>
    </Card>
  );
};

KeyAttributesItem.defaultProps = {
  onRemoveClick: undefined,
  onValueChanged: () => { /* noop */ },
  disabled: false,
};
